module.exports = __webpack_public_path__ + "static/media/mbys_ris_ass.c6c08e2f.png";